if (!customElements.get('hollow-collection-card')) {
  customElements.define('hollow-collection-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const card = this.querySelector('hollow-product-card');
      if (!card) return;
      this.prices = JSON.parse(this.querySelector('[data-collection-prices]')?.textContent || '{}');
      const colors = JSON.parse(this.querySelector('[data-collection-colors]')?.textContent || '{}');
      const styleOptions = this.querySelector('[data-collection-style-options]');
      if (styleOptions) {
        card.querySelector('.ds-product-card__swatches')?.append(...styleOptions.children);
        styleOptions.remove();
      }
      this.querySelectorAll('.js-swatch').forEach(button => {
        const media = colors[button.getAttribute('aria-label')];
        if (!media) return;
        if (!button.classList.contains('is-active') || button.hasAttribute('data-collection-style')) {
          button.dataset.variantImage = media.image;
          button.dataset.variantBackground = media.background;
          button.dataset.variantBadge = media.badge;
        }
      });
      const extra = this.querySelector('.hollow-collection-card__extra');
      if (extra) {
        const prices = card.querySelector('.js-price-container');
        prices?.firstElementChild?.append(extra.querySelector('.hollow-collection-card__compare'));
        const unit = extra.querySelector('.hollow-collection-card__unit');
        if (unit) prices?.append(unit);
        extra.remove();
      }
      this.updatePrice(card.dataset.defaultVariant);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-hollow-variant]');
        if (!button) return;
        if (button.hasAttribute('data-collection-style')) {
          event.preventDefault();
          this.querySelectorAll('.js-swatch').forEach(swatch => {
            const active = swatch === button;
            swatch.classList.toggle('is-active', active);
            swatch.setAttribute('aria-pressed', String(active));
          });
          card.querySelectorAll('.js-product-link').forEach(link => { link.href = button.dataset.variantUrl; });
          card.querySelectorAll('.js-current-price').forEach(price => { price.textContent = button.dataset.variantPrice; });
          for (const [selector, url] of [['.hollow-card-product-image', button.dataset.variantImage], ['.hollow-card-background-image', button.dataset.variantBackground]]) {
            if (url) card.querySelectorAll(selector).forEach(image => { image.removeAttribute('srcset'); image.src = url; });
          }
        }
        this.updatePrice(button.dataset.hollowVariant);
      }, { signal: this.controller.signal });
    }
    updatePrice(id) {
      const price = this.prices?.[id];
      if (!price) return;
      const compare = this.querySelector('.hollow-collection-card__compare');
      if (compare) {
        compare.hidden = !price.on_sale;
        compare.querySelector('[data-compare-money]').textContent = price.compare;
      }
      const unit = this.querySelector('[data-unit-money]');
      if (unit) unit.textContent = price.unit || '';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
